// src/translations/en.js

export const enTranslations = {
    // General / Common
    home: "Home",
    company: "Company",
    services: "Services",
    operations: "Operations",
    sustainability: "Sustainability",
    contactUs: "Contact Us",
    resources: "Resources",
    information: "Information",
    followUsText: "Learn more about our products and services by entering:",
    copyrightSlogan: "Energy & Environmental Services",
    allRightsReserved: "All rights reserved.",
    selectLanguage: "Select Language",
    discoverMore: "Discover More",
    exploreOurServices: "Explore Our Services",
    latestUpdates: "Latest Updates",
    readMore: "Read More",
  
    // Header Specific
    headerTitle: "Header Title",
  
    // Services Dropdown / Categories
    oilAndGas: "Oil and Gas",
    environmental: "Environmental",
    consultoria: "Consulting",
    fluidosPerforacion: "Drilling Fluids",
    fluidosCompletamiento: "Completion Fluids",
    controlSolidos: "Solid Control",
    productosQuimicos: "Chemical Products",
    laboratorio: "Environmental Analysis Laboratory",
    decarbonization: "Decarbonization",
    alquilerEquipos: "Equipment Rental",
  
    // Footer Specific
    workWithUs: "Work With Us",
    termsConditions: "Terms and Conditions",
    pqrs: "PQRS",
    policies: "Policies",
    codeOfEthics: "Code of Ethics",
    certifications: "Certifications",
    brochure: "Brochure",
  
    // Home Page Specific
    innovationInEnergy: "Innovation in Energy",
    sustainableEnvironmentalSolutions: "Sustainable Environmental Solutions",
    advancedOilAndGasServices: "Advanced Oil & Gas Services",
    whoWeAre: "Who We Are",
    whatWeDo: "What We Do",
    newTechnologies: "New Electrification Technologies",
    newTechnologiesDate: "February 4, 2025",
    newTechnologiesDescription: "Baker Hughes launches a trio of electrification technologies for onshore and offshore operations.",
    automatedProduction: "Automated Field Production Solution",
    automatedProductionDate: "February 3, 2025",
    automatedProductionDescription: "Baker Hughes and NNPC/FIRST E&P JV will implement the Leucipa™ automated production solution in the Niger Delta.",
    whoWeAreDescription1: "We are a Colombian company with experience in providing Drilling Fluids, Completion Fluids, Solids Control, and Environmental Analysis Laboratory services accredited by IDEAM. Focused on the development of technology for the entire energy industry, we are represented by an excellent team, highly qualified and with significant experience in the energy sector.",
    whoWeAreDescription2: "Grupo Sierra Alta is the representative of all WEATHERFORD fluid systems. With these, we have participated in the drilling of more than 1400 wells with different operators such as: Ecopetrol, SierraCol, Frontera, Hocol, Occidental, Mansarovar, Interoil, among others. Meeting high-quality standards, we stand out for offering top-quality engineering solutions, tailored to the needs of our clients.",
    whatWeDoDescription1: "We develop and implement the most advanced technologies to serve energy and industrial companies seeking more efficient, reliable, and clean solutions. Our diverse portfolio of technologies and solutions is transforming the way the industry operates today and in the future.",
    whatWeDoDescription2: "We offer specialized services in Drilling Fluids, Completion Fluids, Solids Control, and Environmental Analysis Laboratory. Additionally, we are leaders in the implementation of WEATHERFORD fluid systems, ensuring maximum efficiency and productivity in every project.",
  
    // Operations Page Specific
    operationsPageTitle: "Operations",
    oilAndGasTab: "OIL & GAS",
    ambientalTab: "ENVIRONMENTAL",
  
    // Solid Control Page Specific
    solidControlCTATextStart: "Need an effective solution for",
    solidControlCTATextHighlight: "Solid Control?",
  
    // Add keys for other pages as needed
    // Example:
    // formFullName: "Full Name",
    // formEmail: "Email Address",
    // formSubmit: "Submit",
  };